type UnauthorizedHandler = () => void;

let onUnauthorized: UnauthorizedHandler | null = null;
let unauthorizedNotified = false;

export function setUnauthorizedHandler(handler: UnauthorizedHandler | null) {
  onUnauthorized = handler;
  unauthorizedNotified = false;
}

export function resetUnauthorizedLatch() {
  unauthorizedNotified = false;
}

function notifyUnauthorized() {
  if (unauthorizedNotified) return;
  unauthorizedNotified = true;
  onUnauthorized?.();
}

/** fetch с реакцией на 401 — сбрасываем сессию один раз за «волну» ошибок. */
export async function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const res = await fetch(input, init);
  if (res.status === 401) {
    notifyUnauthorized();
  }
  return res;
}
